import React, { Fragment } from 'react';
import { CoffinSize, CollectFD, DeliverFD, PickupMethod } from '../../views/Enquiry/EnquiryConstants';
import Grid from '../layout/Grid';
import TextField from '../form/TextField';
import Select from '../form/Select';
import Label from '../form/Label';
import StaffAutoComplete from '../form/StaffAutoComplete';
import UserCircle from '../form/UserCircle';

export function PickupOrDeliveryField(props) {
    const { form } = props;
    return (
        <Select
            label="Pickup or Delivery?"
            options={PickupMethod}
            form={form}
            name="PickupMethod"
            onChange={(e, val) => {
                if (val && val === DeliverFD) {
                    form.setState({ PickupID: '0' });
                }
            }}
        />
    );
}

export function Pickup(props) {
    const { form } = props;
    const pickupMethod = form.getField('PickupMethod');
    const assignedStaff = form.getField('Pickup.AssignedStaff');

    const handleSelectStaff = (propertyName, staff) => {
        if (!!staff) {
            delete staff['__typename'];
            const staffList = form.getState(propertyName) || [];
            const idx = staffList.findIndex(person => person.ID === staff.ID);
            if (idx < 0) {
                staffList.push(staff);
                form.setState({ [propertyName]: staffList });
            }
        }
    };

    const handleDeleteStaff = (propertyName, staff) => {
        const staffList = form.getState(propertyName) || [];
        const idx = staffList.findIndex(person => person.ID === staff.ID);
        if (idx < 0) {
            // huh?
        } else {
            staffList.splice(idx, 1);
            form.setState({ [propertyName]: staffList });
        }
    };

    return (
        <Fragment>
            {pickupMethod && pickupMethod === CollectFD && (
                <Grid container bucket>
                    <Grid item>
                        <h4>Organise Pickup</h4>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField label="Pickup Date" type="date" form={form} name="Pickup.Date" />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField label="Pickup Time" type="time" form={form} name="Pickup.Time" />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Select label="Select coffin size" options={CoffinSize} form={form} name="Pickup.CoffinSize" />
                    </Grid>
                    <Grid item>
                        <Label htmlFor={'Pickup.AssignedStaff-input'}>Assigned Staff</Label>
                        <br />
                        <StaffAutoComplete
                            placeholder="Search for a staff name here"
                            selectProps={{ multiple: true }}
                            name="Pickup.AssignedStaff"
                            onSelect={(_, person) => handleSelectStaff('Pickup.AssignedStaff', person)}
                        />
                        {assignedStaff && (
                            <div className="user-container" style={{ marginTop: 6 }}>
                                {assignedStaff.map((p, i) => (
                                    <UserCircle
                                        key={p.ID || i}
                                        member={p}
                                        onDelete={() => handleDeleteStaff('Pickup.AssignedStaff', p)}
                                    />
                                ))}
                            </div>
                        )}
                    </Grid>
                    <Grid item>
                        <TextField
                            label="Comment"
                            name="Pickup.Comment"
                            form={form}
                            multiline
                            button={{
                                variant: 'secondary',
                                children: '+ Add comments'
                            }}
                        />
                    </Grid>
                </Grid>
            )}
        </Fragment>
    );
}

export default Pickup;
